module.exports = __webpack_public_path__ + "static/media/vision-2021-footer.89b89a5e.png";